module.exports = __webpack_public_path__ + "fonts/opensans-extrabold.bbbfcfa2.woff2";